export enum paymentTypeId {
  card = 1,
  paypal = 3,
  invoice = 4,
}
